function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { toHHMMSS } from "@common/services/helpers";
import { INITIAL_TIME_FORMAT, ONE_HOUR_IN_SECONDS } from "@config/constants";
import React, { Component } from "react";
var TimeInfo = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(TimeInfo, Component);
    var _super = _create_super(TimeInfo);
    function TimeInfo(props) {
        _class_call_check(this, TimeInfo);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            duration: 0,
            ratio: 0,
            progressBarWidth: 0
        };
        return _this;
    }
    _create_class(TimeInfo, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this_props = this.props, videoPlayer = _this_props.videoPlayer, currentTime = _this_props.currentTime;
                var changeInDuration = videoPlayer.video.duration !== nextProps.videoPlayer.video.duration;
                var changeInCurrentTime = currentTime !== nextProps.currentTime;
                return changeInDuration || changeInCurrentTime;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, videoPlayer = _this_props.videoPlayer, currentTime = _this_props.currentTime;
                var duration = videoPlayer.video.duration;
                var endTimeFormat = duration ? toHHMMSS(duration) : INITIAL_TIME_FORMAT;
                var currentTimeFormat = currentTime > 0 ? toHHMMSS(currentTime) : INITIAL_TIME_FORMAT;
                var currentWidth = currentTime >= ONE_HOUR_IN_SECONDS ? "60px" : "40px";
                return /*#__PURE__*/ _jsxs("div", {
                    className: "time-info-wrapper player",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "current-time d-inline-block",
                            style: {
                                width: currentWidth
                            },
                            children: currentTimeFormat
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "end-time",
                            children: [
                                " / ",
                                endTimeFormat
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return TimeInfo;
}(Component);
export default TimeInfo;
